/* SkillFoot — Popup promo 2+1 d'accueil. JS léger, sans dépendance. */
(function () {
  var root = document.querySelector('[data-sf-popup]');
  if (!root) return;

  var KEY = 'sf_promo_popup_seen';
  var delay = parseInt(root.getAttribute('data-delay'), 10);
  var freqHours = parseInt(root.getAttribute('data-frequency'), 10);
  if (isNaN(delay)) delay = 1500;
  if (isNaN(freqHours)) freqHours = 36;
  // UX mobile : ne s'ouvre qu'après une vraie preuve d'engagement.
  // Conditions CUMULATIVES : >= 12s sur la page ET >= 1400px de scroll,
  // et jamais tant que la bannière cookies Shopify est visible.
  var MIN_TIME = Math.max(delay, 12000);
  var MIN_SCROLL = 1400;
  var startedAt = Date.now();

  // Fréquence : ne pas ré-afficher avant freqHours après fermeture/visite.
  try {
    var last = parseInt(localStorage.getItem(KEY), 10);
    if (!isNaN(last) && (Date.now() - last) < freqHours * 3600 * 1000) return;
  } catch (e) { /* localStorage indispo : on affiche quand même */ }

  var overlay = root.querySelector('[data-sf-popup-overlay]');
  var dialog = root.querySelector('[data-sf-popup-dialog]');
  var closeBtn = root.querySelector('[data-sf-popup-close]');
  var opened = false;
  var lastFocused = null;

  function markSeen() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function focusables() {
    return dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function open() {
    if (opened) return;
    opened = true;
    lastFocused = document.activeElement;
    root.hidden = false;
    // Force reflow puis classe d'entrée (fade + scale).
    void root.offsetWidth;
    root.classList.add('sf-popup--open');
    document.documentElement.classList.add('sf-popup-lock');
    document.addEventListener('keydown', onKeydown);
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function close() {
    if (!opened) return;
    opened = false;
    markSeen();
    root.classList.remove('sf-popup--open');
    document.documentElement.classList.remove('sf-popup-lock');
    document.removeEventListener('keydown', onKeydown);
    cleanupTriggers();
    var hide = function () { root.hidden = true; };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) hide();
    else setTimeout(hide, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
  }

  // CTA / clic ailleurs : on enregistre aussi la visite.
  var cta = root.querySelector('[data-sf-popup-cta]');
  if (cta) cta.addEventListener('click', markSeen);

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);

  // Bannière cookies Shopify visible ? (Privacy banner natif, plusieurs variantes de markup.)
  function cookieBannerVisible() {
    var banners = document.querySelectorAll('#shopify-pc__banner, shopify-privacy-banner, .shopify-cookies-banner, #shopify-privacy-banner');
    for (var i = 0; i < banners.length; i++) {
      var b = banners[i];
      if (b.hasAttribute('hidden')) continue;
      var r = b.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  // Déclencheur : délai ET scroll requis tous les deux, sans bannière cookies visible.
  function maybeOpen() {
    if (opened) return;
    if (Date.now() - startedAt < MIN_TIME) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y <= MIN_SCROLL) return;
    if (cookieBannerVisible()) return;
    open();
  }
  // Re-check au bout du délai mini (couvre le cas « déjà scrollé avant 12s »),
  // sinon chaque scroll re-teste les conditions (dont l'acceptation cookies).
  var timer = setTimeout(maybeOpen, MIN_TIME + 100);
  function onScroll() { maybeOpen(); }
  function cleanupTriggers() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // open() ne s'exécute qu'une fois (garde opened) — on nettoie au close().
})();
